
const pro = {
    
    PRO_BASE : 'http://prod.api.dgsjyyy.com',// 线上环境地址

}
const dev = {
    DEV_BASE : 'http://prod.api.dgsjyyy.com',// 线上环境地址
    // DEV_BASE : 'http://192.168.41.142:10081/',// 开发环境地址
    // DEV_BASE : 'http://192.168.41.187:10081/',// 开发环境地址
    //  DEV_BASE : 'http://192.168.41.106:10081',// 开发环境地址
    //  DEV_BASE : 'http://192.168.41.200:10081',// 开发环境地址

    // DEV_BASE:"http://test.backend.dgsjyyy.com"
}

const config = {
    pro,
    dev
}
export default config


// WEBPACK FOOTER //
// ./src/utils/config.js